import { Action, Field } from '@/components/general/list-view/types'
import { LocaleString } from '@/components/types'
import { Feature } from '@/pinia/feature'

export type CsvColumn = { value: string; labelKey: string }

export type FeatureList = {
  type: string
  icon: string
  title: LocaleString
  fields?: Field[]
  searchable?: boolean
  children?: Feature[]
  actions?: Action[]
  listMaxActions?: number
  mainPathFilter?: boolean
  categoryFilter?: boolean
  csvColumns?: CsvColumn[]
  component?: string
}

export function createFeatureList({
  type,
  icon,
  title,
  fields = [],
  searchable = true,
  children,
  actions,
  listMaxActions = 1,
  mainPathFilter = true,
  categoryFilter = false,
  csvColumns,
  component = 'EntityDashboard'
}: FeatureList): Feature {
  return {
    name: type.toLowerCase(),
    enabled: true,
    isRoute: true,
    title,
    component,
    access: ['READER', 'EDITOR', 'CREATOR', 'ADMIN'].map((access) => `FEAT_${type}_${access}`),
    props: {
      icon,
      type,
      searchable,
      fields,
      actions,
      listMaxActions,
      mainPathFilter,
      categoryFilter,
      csvColumns
    },
    children
  }
}
